export default __webpack_public_path__ + "static/media/corndog.63d454c2.png";